import React from 'react';
import { ShieldIcon } from './icons/ShieldIcon';
export function Guarantee() {
  return <section id="garantia" className="py-12 px-4 bg-white" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <div className="bg-[#FAF8F4] rounded-2xl p-8 md:p-10 border border-[#D4C4B0]/20 text-center" data-id="element-100">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-white rounded-xl mb-5 text-[#E5A5A0] border border-[#D4C4B0]/20" data-id="element-101">
            <ShieldIcon className="w-7 h-7" data-id="element-102" />
          </div>

          <h2 className="text-xl md:text-2xl font-semibold text-[#3D3028] mb-4" data-id="element-103">
            GARANTÍA TOTAL DE 7 DÍAS – SIN RIESGO
          </h2>

          <p className="text-sm md:text-base text-[#3D3028]/70 mb-4 leading-relaxed" data-id="element-104">
            Probalo tranquila. Si en los primeros 7 días sentís que no es para
            vos, te devolvemos el 100% de tu dinero sin preguntas.
          </p>

          <p className="text-[#E5A5A0] font-medium text-base" data-id="element-105">
            El riesgo es mío, no tuyo
          </p>
        </div>
      </div>
    </section>;
}